import React from 'react';

import InTableTextArea from './InTableTextArea';
import SSRichTextEditor from './ssRichTextEditor';
import TextArea from './TextArea';
import { isTrue } from '../../../utils/commonUtils';

const SSTextArea = ({ supportRichText, inTable, ...otherProps }) => {
  const InputComponent = isTrue(supportRichText)
    ? SSRichTextEditor
    : inTable
    ? InTableTextArea
    : TextArea;

  return <InputComponent {...otherProps} />;
};

export default SSTextArea;
